import React, { Component } from 'react';
import { connect } from 'react-redux';

// 3rd party
import { reduxForm, Field } from 'redux-form';
import { TextField } from 'redux-form-material-ui';

// components
import CheckboxGroup from '../../../components/CheckboxGroup';
import FormFooter from '../../../../../components/FormFooter';
import AlertMessage from '../../../../../components/AlertMessage';

// utils
import { required, validEmail } from '../../../../../utils/validators';
import { NOTIFICATION_OPTIONS } from '../../../shared/notification-types';
import {
  getUpdateNotificationSubUi,
  getAddNotificationSubUi,
} from '../../../../../redux/selectors';
import { updateAddSubClearErrors } from '../../../../../redux/admin-notification-settings';

class SubscriberForm extends Component {
  componentWillUnmount() {
    this.props.dispatch(updateAddSubClearErrors());
  }

  _saveSubscriber = (formValues) => {
    this.props.onSubmit(formValues);
  };

  render() {
    const {
      invalid, handleSubmit, onDismiss, userData, formUi,
    } = this.props;

    return (
      <form
        onSubmit={handleSubmit(this._saveSubscriber)}
        className="SubscriberForm"
      >
        <h3 className="SubscriberForm__title">
          {userData
            ? `Editando usuário ${userData.name}`
            : 'Adicionar novo usuário a lista de notificações'}
        </h3>

        <div className="SubscriberForm__fields">
          <div className="SubscriberForm__fields-subscriber">
            <Field
              name="name"
              floatingLabelText="Nome"
              fullWidth
              component={TextField}
              validate={[required]}
            />
            <Field
              name="email"
              floatingLabelText="E-mail"
              fullWidth
              component={TextField}
              validate={[required, validEmail]}
            />
          </div>

          <div className="SubscriberForm__fields-notifications">
            <Field
              name="notificationOptions"
              props={{
                label: 'Notificações Ativas',
                options: NOTIFICATION_OPTIONS,
              }}
              component={CheckboxGroup}
              validate={[required]}
            />
          </div>
        </div>

        {/* =========================== */}
        {/* ====== ERROR MESSAGE ====== */}
        {/* =========================== */}
        {formUi.error && <AlertMessage message={formUi.error} error box />}

        <FormFooter
          invalid={invalid}
          entityName="usuário"
          onCancel={onDismiss}
          onRemove={null}
        />
      </form>
    );
  }
}

SubscriberForm.propTypes = {};
SubscriberForm.defaultProps = {};

// Redux
function mapStateToProps(state, ownProps) {
  const { userData } = ownProps;

  return userData
    ? {
      form: userData.email,
      initialValues: {
        name: userData.name,
        email: userData.email,
        notificationOptions: userData.typeNotification
          .filter(notification => notification.active)
          .map(notification => notification.type),
      },
      formUi: getUpdateNotificationSubUi(state),
    }
    : {
      form: 'adminCompaniesSubscriber',
      initialValues: {
        name: '',
        email: '',
        notificationOptions: [],
      },
      formUi: getAddNotificationSubUi(state),
    };
}

export default connect(mapStateToProps)(reduxForm()(SubscriberForm));
